// extracted by mini-css-extract-plugin
export var chevron = "_2q-2";
export var chevronCollapsed = "_2q-3";
export var collapsibleHeader = "_2q-1";
export var container = "_2q-0";